module.exports = __webpack_public_path__ + "static/media/47pic.95acf96f.jpg";